import Joi from 'joi';

export const getTeamActivitySummaryReport = {
  query: Joi.object().keys({
    source: Joi.string(),
    startDate: Joi.date().iso(),
    endDate: Joi.date().iso(),
  }),
};